// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridViagens_ButtonSection__fbY89","UlCuston":"gridViagens_UlCuston__yLYSX"};